import comp from "./AssessmentDraftModal";
export default comp;
